import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * Centralized JSON-LD structured data helper.
 * Usage: <StructuredData data={{ '@type': 'Service', ... }} />
 * Or pass an array for multiple schemas.
 */
const StructuredData = ({ data }) => {
  if (!data) return null;

  const schemas = Array.isArray(data) ? data : [data];

  return (
    <Helmet>
      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify({ '@context': 'https://schema.org', ...schema })}
        </script>
      ))}
    </Helmet>
  );
};

export default StructuredData;
